import { render, staticRenderFns } from "./UsersAndRolesTable.vue?vue&type=template&id=2d9fd57f"
import script from "./UsersAndRolesTable.vue?vue&type=script&lang=js"
export * from "./UsersAndRolesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports